import { memo } from 'react';
import { SocialLink } from '~/lib/data-contract';
import styles from './meta-area.module.css';
import { RawHtml } from '~/shared/components/RawHtml/RawHtml';
import { CMSLink, MediaImage, Typography } from '~/shared/components';
import { weakKey } from '~/shared/utils/jsx';

type MetaAreaProps = {
    copyRightNotice?: string;
    soMeLinks?: SocialLink[];
    footerMeta?: string;
};

export const MetaArea = memo(({ copyRightNotice, soMeLinks, footerMeta }: MetaAreaProps) => {
    return (
        <div className={styles.root}>
            {footerMeta && (
                <div className={styles.textWrapper}>
                    <RawHtml html={footerMeta} backgroundColor="dark" linkStrokeMode="whileHover" />
                </div>
            )}
            <div className={styles.meta}>
                {copyRightNotice && <Typography as="p">{copyRightNotice}</Typography>}
                <div className={styles.someItems}>
                    {soMeLinks?.map(({ link, image }) =>
                        link ? (
                            <CMSLink
                                href={link?.url}
                                key={weakKey(link)}
                                rel="noopener noreferrer"
                                target={link?.target || '_blank'}
                            >
                                {image?.src && (
                                    <MediaImage
                                        src={image.src}
                                        width={24}
                                        height={24}
                                        alt={image.alt || ''}
                                    />
                                )}
                            </CMSLink>
                        ) : null
                    )}
                </div>
            </div>
        </div>
    );
});
